import React from 'react'
import { useStaticQuery, graphql } from "gatsby"

const Head = ({ title, metatags, description, subtitle, jsonld, children, ...props }) => {
    const { site, videos: { nodes: videos } } = useStaticQuery(
        graphql`
          query {
            site {
              siteMetadata {
                title
                description
                author
              }
            }
            videos:allMediaHtml5Video {
                nodes {
                    name
                    created
                    r:relationships {
                        thumbnail:field_poster {
                            r:relationships {
                                image:field_media_image {
                                    file:localFile {
                                        publicURL
                                    }
                                }
                            }
                        }
                        video:field_media_video_file {
                            file:localFile {
                                publicURL
                            }
                        }
                    }
                }
            }
          }
        `
      )

    const meta = !metatags ? {
        description: subtitle && subtitle.string,
        keywords: []
      } : JSON.parse(metatags);

    const extra = []

    const metaDescription = description || site.siteMetadata.description

    const prefix = process.env.GATSBY_SITE === 'residential' ? 'www' : 'business';

    return (
        <>
            <title>{title} | {site.siteMetadata.title}</title>
            {[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    name: `og:site`,
                    content: props.og_site_name || site.siteMetadata.title,
                },
                {
                    name: `og:title`,
                    content: props.og_title || title,
                },
                {
                    name: `og:description`,
                    content: props.og_description || metaDescription,
                },
                {
                    name: 'og:image',
                    content: `https://${prefix}.novaenergy.co.nz/og-image.jpg`
                },
                {
                    name: 'og:image:width',
                    content: '1200'
                },
                {
                    name: 'og:image:height',
                    content: '627'
                },
                {
                    name: `og:type`,
                    content: `website`,
                },
                {
                    name: 'apple-itunes-app',
                    content: process.env.GATSBY_APP_STORE_ID
                },{
                    name: 'google-play-app',
                    content: process.env.GATSBY_PLAY_STORE_ID
                },
                {
                    name: 'twitter:card',
                    content: 'summary_large_image'
                }, {
                    name: 'twitter:title',
                    content: `Nova Energy: ${title}`
                }, {
                    name: 'twitter:description',
                    content: metaDescription
                }, {
                    name: 'twitter:image',
                    content: `https://${prefix}.novaenergy.co.nz/og-image.jpg`
                }, {
                    name: 'twitter:image:alt',
                    content: title
                }
            ].map((tag,i) => <meta key={i} property={tag.name} content={tag.content} />)}
            {jsonld && (
                <script type="application/ld+json">
                {`{
                    "@context": "https://schema.org",
                    "@graph": [
                    {
                        "@type": "WebSite",
                        "url": "https://${prefix}.novaenergy.co.nz",
                        "potentialAction": {
                        "@type": "SearchAction",
                        "target": "https://${prefix}.novaenergy.co.nz/search?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                        }
                    },
                    {
                        ${jsonld}
                    }
                    ]
                }`}</script>
            )}
            {
                videos.map(video => (
                    <script key={video.name} type="application/ld+json">{`{
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        "@name": "${video.name}",
                        "uploadDate": "${video.created}",
                        "thumbnailUrl": [${[video.r.thumbnail].map(thumbnail => {
                            if(thumbnail) {
                                return `"https://${prefix}.novaenergy.co.nz${encodeURI(video.r.thumbnail.r.image.file.publicURL)}"`
                            }
                        })}]
                        "contentUrl": "https://${prefix}.novaenergy.co.nz${encodeURI(video.r.video.file.publicURL)}",
                        "regionsAllowed": "NZ"
                    }`}</script>
                ))
            }
            {children}
        </>
    )
}
export default Head;